import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import config from "../../config/config";
import api from "../../config/axios";
import "./style.css";
import ShowPhotos from "../../components/showPhotos/showPhotos";
import ImageLoader from "../../components/ImageLoader/ImageLoader";
import Loader from "../../components/Loader/Loader";
import ProductCard from "../../components/ProductCard/ProductCard";


const ProductView = () => {
  const [selectedImage, setSelectedImage] = useState(0);
  // const [cartCount, setCartCount] = useState(0);
  const [product, setProduct] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [modalImageIndex, setModalImageIndex] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(true);
  const [products, setProducts] = React.useState([]);


  const { id } = useParams(); // 👈 get id from URL

  const openModal = (index) => {
    setModalImageIndex(index);
    setIsModalOpen(true);
  };
  useEffect(() => {
    const loadProducts = async () => {
      try {
        let list = products;

        if (list.length === 0) {
          const res = await api.get("/products");
          list = res.data;
        }

        const currentIndex = list.findIndex(pd => pd.id == id);
        if (currentIndex === -1) {
          setProducts(list);
          return;
        }


        const before = list
          .slice(0, currentIndex)
          .filter(pd => pd.stock?.quant_available > 0);

        const after = list
          .slice(currentIndex)
          .filter(pd => pd.stock?.quant_available > 0);

        setProducts([...after,...before]);
      } catch (err) {
        console.error(err);
      }
    };

    loadProducts();
  }, [id, products]);

  useEffect(() => {
    api
      .get(`/products/${id}`)
      .then((res) => {
        setProduct(res.data);
        setIsLoading(false);
        window.scrollTo(0, 0);
      })
      .catch((err) => console.error("Erro ao buscar produto:", err));
  }, [id]);



  if (!product) {
    return <h2>Product not found!</h2>;
  }


  // const handleAddToCart = () => {
  //   setCartCount(cartCount + 1);
  // };

  const handleWhatsApp = () => {
    const message = `Ola, Estou interresado no ${product.name} por ${product.stock.price}$00. Pode dizer mais sobre este produto?`;
    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://wa.me/${config.Number_Whatsapp}?text=${encodedMessage}`,
      "_blank"
    );
  };

  return (
    <div>
      <div className="container-view">
        <Loader text="Loading products..." is_shown={isLoading} />
        <div className="product-container">
          <div>
            <div onClick={() => openModal(selectedImage)}>
              <ImageLoader
                src={product.images && product.images[selectedImage].image_url}
                alt={product.name}
                className="main-image"
              />
            </div>
            <div className="image-gallery">
              <div className="thumbnail-container">
                {product.images &&
                  product.images.map((image, index) => (
                    <div
                      key={index}
                      onClick={function () {
                        setSelectedImage(index);
                        openModal(index);
                      }}
                    >
                      <ImageLoader
                        src={image.image_url}
                        alt={`Thumbnail ${index + 1}`}
                        className={`thumbnail ${selectedImage === index ? "active" : ""
                          }`}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="product-info">
            <h1 className="product-title">{product.name}</h1>
            <div className="product-price">{product.stock.price}$00</div>

            <div className="stock-info">
              {product.stock.quant_available > 0 ? (
                <>
                  <span className="in-stock">
                    <i className="fas fa-check-circle"></i> No Stock
                  </span>
                  {product.stock.quant_available < 3 && <span>({product.stock.quant_available} disponivel)</span>}
                </>
              ) : (
                <span className="out-of-stock">
                  <i className="fas fa-times-circle"></i> Sem Stock
                </span>
              )}
            </div>
            <div className="actions">
              <button className="whatsapp-btn" onClick={handleWhatsApp}>
                <i className="fab fa-whatsapp"></i> Envia messagem via WhatsApp
              </button>
              {/* <button className="add-to-cart" onClick={handleAddToCart}>
              <i className="fas fa-shopping-cart"></i> Add to Cart
            </button> */}
            </div>

            <p className="product-description-view">{product.description}</p>

            {product.specifications && (
              <div className="specs">
                <h3>Especificações</h3>
                <ul className="specs-list">
                  {product.specifications &&
                    product.specifications.map((spec, index) => (
                      <li key={index}>
                        <span className="spec-name">{spec.name}:</span>
                        <span>{spec.value}</span>
                      </li>
                    ))}
                </ul>
              </div>
            )}

            <div className="delivery-info">
              <h3>Entrega:</h3>
              <ul>
                <li>Gratis dentro de Praia</li>
                <li>Dentro de Assomada (custo: 200$00 )</li>
                <li>Envio para outras ilhas atraveis do correio</li>
              </ul>
            </div>

            <div className="delivery-info">
              <h3>Contato:</h3>
              <ul>
                <li>Telefone: (238) 992 90 63</li>
              </ul>
            </div>
          </div>
        </div>

        {/* <div className="reviews">
        <h2>Customer Reviews</h2>
        {product.reviews.map((review, index) => (
          <div key={index} className="review">
            <div className="review-header">
              <span className="reviewer">{review.user}</span>
              <span className="rating">
                {"★".repeat(review.rating)}
                {"☆".repeat(5 - review.rating)}
              </span>
            </div>
            <p>{review.comment}</p>
          </div>
        ))}
      </div> */}
        <ShowPhotos
          product={product}
          index={modalImageIndex}
          is_modalOpen={isModalOpen}
          set_is_ModalOpen={setIsModalOpen}
        ></ShowPhotos>
      </div>

      <div className="container">
        <Loader text="Loading products..." is_shown={isLoading} />
        <div className="products-grid">
          {products
            .filter(pd => pd.id != id)
            .map(pd => (
              <ProductCard key={pd.id} product={pd} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default ProductView;
